import React from 'react'

import Event from '../Event'

function Tournament() {
    return <Event />
}

export default Tournament
